import './index.css';
import './config/i18n';

import {
  createQueryClient,
  ToastsProvider,
} from '@brunommsilva/react-foundations';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './app/App';
import AuthProvider from './components/auth/auth-provider';
import GlobalErrorBoundary from './components/error-boundary/global-error-boundary';
import I18nLocalizationProvider from './components/localization/i18n-localization-provider';

const queryClient = createQueryClient();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const theme = createTheme();

// Render React app after config is loaded
createRoot(rootElement).render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <ThemeProvider theme={theme}>
        <I18nLocalizationProvider>
          <QueryClientProvider client={queryClient}>
            <ToastsProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </ToastsProvider>
          </QueryClientProvider>
        </I18nLocalizationProvider>
      </ThemeProvider>
    </GlobalErrorBoundary>
  </React.StrictMode>
);
